import React, { Component } from 'react'
import Modal from 'react-responsive-modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSync, faTimesCircle, faCheck } from '@fortawesome/free-solid-svg-icons'

class DeleteModal extends Component {

    render() {
        const { visible, closeModal, func, post, title } = this.props
        const { deleted, deleting, error } = post
        return (
            <Modal center={true} focusTrapped={false} open={visible} onClose={closeModal} showCloseIcon={false} classNames={{ overlay: 'overlay', modal: 'modal' }} >
                <div className='modal'>
                    {
                        deleted ?
                            <div className='col flex-center'>
                                <h2>Supprimé</h2>
                                <FontAwesomeIcon className='success' size='2x' icon={faCheck} />
                                <button type='button' className='norm-btn2 ok mt-20' onClick={() => closeModal()}>Ok</button>
                            </div>
                            :
                            deleting ?
                                <div className='col flex-center'>
                                    <h2>Suppression...</h2>
                                    <FontAwesomeIcon size='2x' icon={faSync} spin />
                                </div>
                                :
                                error ?
                                    <div className='col flex-center'>
                                        <FontAwesomeIcon className='error' size='2x' icon={faTimesCircle} />
                                        <p className='full center px-0'>{`${error.status}`}</p>
                                        <p className='full center px-0'>{`${error.msg.length > 200 ? error.msg.substring(0, 200)+'...' : error.msg}`}</p>
                                        <p className='full center px-0'>Ce rapport d'erreur a été sauvegardé</p>
                                        <button type='button' className='norm-btn2 ok' onClick={() => closeModal()}>Ok</button>
                                    </div>
                                    :
                                    <div className='col flex-center'>
                                        <h2>{`Supprimer ${title} ?`}</h2>
                                        <div className='row full flex-center mt-20'>
                                            <button type='button' className='norm-btn2 ok mx-20' onClick={() => func()}>Ok</button>
                                            <button type='button' className='norm-btn2 no mx-20' onClick={() => closeModal()}>Annuler</button>
                                        </div>
                                    </div>
                    }
                </div>
            </Modal>
        )
    }
}

export default DeleteModal
